/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { BaseToken, BaseTokenInterface } from "../BaseToken";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "priceFeed",
        type: "address",
      },
    ],
    name: "PriceFeedChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "enum IBaseToken.Status",
        name: "status",
        type: "uint8",
      },
    ],
    name: "StatusUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "WhitelistAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "WhitelistRemoved",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "addWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "interval",
        type: "uint256",
      },
    ],
    name: "cacheTwap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "closedPrice",
        type: "uint256",
      },
    ],
    name: "close",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "close",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getClosedPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "interval",
        type: "uint256",
      },
    ],
    name: "getIndexPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getPausedIndexPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getPausedTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getPriceFeed",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "nameArg",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbolArg",
        type: "string",
      },
      {
        internalType: "address",
        name: "priceFeedArg",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "isClosed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "isInWhitelist",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isOpen",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "mintMaximumTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "removeWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "priceFeedArg",
        type: "address",
      },
    ],
    name: "setPriceFeed",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class BaseToken__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<BaseToken> {
    return super.deploy(overrides || {}) as Promise<BaseToken>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): BaseToken {
    return super.attach(address) as BaseToken;
  }
  connect(signer: Signer): BaseToken__factory {
    return super.connect(signer) as BaseToken__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BaseTokenInterface {
    return new utils.Interface(_abi) as BaseTokenInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BaseToken {
    return new Contract(address, _abi, signerOrProvider) as BaseToken;
  }
}
